import { createContext } from "react";
import { ChatContextType, AgentState, ChatHistoryItem } from "./type";
import { Run } from "../../services/perspective_api/__generated__/perspective_server-types";

const defaultAgentState: AgentState = {
  status: "idle",
  currentIteration: 0,
  maxIterations: 15,
  reasoning: "",
  reasoningHistory: [],
  sqlQueries: [],
  docSearches: [],
  charts: [],
};

const defaultValue: ChatContextType = {
  isConnected: false,
  messages: [],
  setMessages: () => {},
  sendMessage: () => {},
  connectChat: (run: Run | null, context: string) => {},
  disconnectChat: () => {},
  isAwaitingResponse: false,
  chatSessionId: null,
  chatContext: null,
  agentState: defaultAgentState,
  // Chat history
  chatHistory: [],
  chatHistoryLoading: false,
  fetchChatHistory: () => {},
  loadChatFromHistory: () => {},
};

export const ChatContext = createContext(defaultValue);
